package com.wintermar.inspection.feature.presentation.inspection.landing

sealed class InspectionLandingEvent {
    data class NavigateToInspectionAnswer(val inspectionId: String) : InspectionLandingEvent()
}
